import { useSelector } from 'react-redux';

import { IntlProvider } from 'react-intl';
import combinedMessages from 'i18n/combinedMessages';
import { LOCALES } from 'i18n/locales';

const IntlProviderWrapper = ({ children }) => {
    const currentLocale = useSelector(state => state?.locale?.current) || LOCALES.ENGLISH;

    return (
        <IntlProvider
            messages={combinedMessages[currentLocale]}
            locale={currentLocale}
            defaultLocale={LOCALES.ENGLISH}
        >
            { children }
        </IntlProvider>
    );
};

export default IntlProviderWrapper;
